var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavInformation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.6 18.5",
    className: "needfill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M16.8,18.5c-1.5,0-2.8-1.2-2.8-2.8v-7c0-.4,.3-.8,.8-.8h3c1,0,1.8,.8,1.8,1.8v6c0,1.5-1.3,2.8-2.8,2.8Zm-1.2-9v6.2c0,.7,.6,1.2,1.2,1.2s1.2-.6,1.2-1.2v-6c0-.1-.1-.2-.2-.2h-2.2Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M10.8,5.5H4.8c-.4,0-.8-.4-.8-.8s.4-.7,.8-.7h6c.4,0,.8,.3,.8,.8s-.4,.7-.8,.7Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M10.8,9.3H4.8c-.4,0-.8-.3-.8-.8s.3-.8,.8-.8h6c.4,0,.8,.3,.8,.8s-.4,.8-.8,.8Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M7.8,13.5h-3c-.4,0-.8-.3-.8-.8,0-.4,.3-.7,.8-.7h3c.4,0,.8,.3,.8,.7,0,.5-.4,.8-.8,.8Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "needfill",
    d: "M16.8,18.5H2.8c-1.5,0-2.8-1.2-2.8-2.8V1.7C0,.7,.8,0,1.8,0H13.8c1,0,1.8,.8,1.8,1.8v7c0,.4-.3,.8-.8,.8s-.8-.3-.8-.8V1.7c0-.1-.1-.2-.2-.2H1.8c-.1,0-.2,.1-.2,.2V15.7c0,.7,.6,1.2,1.2,1.2h14c.4,0,.8,.3,.8,.8s-.4,.8-.8,.8Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavInformation);
export default __webpack_public_path__ + "static/media/nav_information.8c7cd66afcfa250148301445e067d242.svg";
export { ForwardRef as ReactComponent };